<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <h3>{{ pageTitle }}</h3>
      <hr>
      
      <AppForm
        v-show="pageShowData"
        ref="pageForm" 
        v-bind:formParameter="PARAM"
        v-bind:permission="permission"
        v-on:form-input="onFormInput" >

        <div
          slot="jt-form-slot-sectionProductSubscriptionLease">
          <PagePLProductChangeFormLease
            ref="pageTableLease"
            v-on:lease-season-change="onLeaseSelected" />
        </div>

        <div
          slot="jt-form-slot-sectionProductChangeSummary"
          class="col-12 table-responsive">
          <table class="table table-bordered">
            <tr>
              <th>Status</th>
              <th>Parking Product</th>
              <th>Deposit (RM)</th>
              <th>Parking Fee (RM)</th>
            </tr>
            <tr 
              v-show="pageSeasonChanged && pageSeasonChanged.length > 0"
              v-for="(pageSeason, pageSeasonIndex) in pageSeasonChanged"
              v-bind:key="pageSeasonIndex">
              <td>{{ pageSeason['status'] }}</td>
              <td>{{ pageSeason['product'] }}</td>
              <td>{{ pageSeason['deposit'] }}</td>
              <td>{{ pageSeason['parkingFees'] }}</td>
            </tr>
          </table>
        </div>
        
      </AppForm>

      <TemplateFeedback ref="pageFeedback" />

      <TemplateFeedback ref="warning" />

      <button v-show="pageShowData" v-on:click="onCancelButtonClick" type="button" class="btn btn-default">
        Cancel
      </button>

      <TemplateButton v-show="hasAddPermission() && pageShowAdd && pageCanAdd" v-on:click="onSaveButtonClick" type="button" class="btn btn-success">
        Submit Application
      </TemplateButton>

      <TemplateButton v-show="hasEditPermission() && pageShowEdit && pageCanEdit" v-on:click="onSaveButtonClick" type="button" class="btn btn-success">
        Submit Application
      </TemplateButton>

      <div class="btn-group" v-show="(hasApprovePermission() || hasRejectPermission() || hasVoidPermission()) && approvalShow">
        <button type="button" class="btn btn-danger dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          Approval Action
        </button>
        <div class="dropdown-menu">
          <a v-show="hasApprovePermission() && approvalShowApprove" class="dropdown-item" href="#" v-on:click.prevent="onApplicationApproveClick" >Approve Application</a>
          <a v-show="hasRejectPermission() && approvalShowReject" class="dropdown-item" href="#" v-on:click.prevent="onApplicationRejectClick" >Reject Application</a>
          <a v-show="hasVoidPermission() && approvalShowVoid" class="dropdown-item" href="#" v-on:click.prevent="onApplicationVoidClick" >VOID Application</a>
        </div>
      </div>

      <TemplateButton v-show="false && approvalShowComplete" v-on:click="onCompleteButtonClick" type="button" class="btn btn-danger">
        Complete
      </TemplateButton>
      
      <AppModalForm 
        ref="pageApprovalModal" 
        v-bind:formParameter="[]"
        v-bind:modalShowDelete="false"
        v-bind:modalShowEdit="false"
        v-bind:modalShowAdd="false">
        <div>
          {{ approvalText }}
        </div>
        <div v-show="approvalReject">
          <br>
          <label>Reason of Reject</label>
          <input class="form-control" v-model="approvalRejectReason">
          <label class="error form-control-feedback">{{approvalRejectReasonError}}</label>
        </div>
        <TemplateButton slot="modal-footer-after" @click="pageApprovalModalConfirm" type="button" class="btn btn-success">
          Confirm
        </TemplateButton>
      </AppModalForm>

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppForm from "@/components/App/AppForm";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"
import PagePLProductChangeFormLease from "@/components/Page/ParkingLicense/PagePLProductChangeFormLease";

var querystring = require('querystring');
var moment = require('moment');

let commencementDateValidate = function(date) {
  return true;
}

const PARAM = [
  {
    key: 'carparkID',
    text: 'Car Park',
    form_select: {
      data: [],
      formatSelectOptionValue: (data) => data.id, 
      formatSelectOptionText: (data) => data.carparkCode ? `${data.carparkCode} - ${data.name}` : data.name,
    },
    form_chosen: true,
    form_edit_input_attr: {
      disabled: true,
    },
  },
  {
    key: 'licenseID',
    text: 'Parking License',
    form_select: {
      data: [],
      formatSelectOptionText: option => {
        let text = helper.plFormPLNum(option.licenseOperatorNum, option.carparkID);
        let customer = option['_customer'];
        text += customer ? ` - ${customer.name} (${customer.nationalID})` : '';
        return text;
      },
    },
    form_chosen: true,
    form_edit_input_attr: {
      disabled: true,
    },
  },
  {
    key: 'sectionProductSubscription',
    form_section: 'Product Subscription',
  },
  {
    key: '_lease',
    form_label_attr: { style: 'display:none'},
    form_select: {
      data: [],
      formatSelectOptionText: option => {
        if(typeof option === 'string') {
          return option;
        }
        let text = `${option['leaseZone']} - ${option['leaseProductName']} - ${option['parkerName']} `;
        if(option['isParkAide']) {
          text += '(Passcard: ParkAide Blocked)';
          if(new moment() > helper.parseDateTime(option['commencementDate'])) {
            if(!option['isBlock']) {
              text += '(Passcard: ParkAide Active)';
            }
          }
        } else {
          text += option['leasePasscard'] ? '(Passcard: ' + option['leasePasscard'] + ')' : '';
        }
        return text;
      },
    },
    form_edit_hide: true,
    form_chosen: true,
    form_input_validation: [],
    // form_input_attr: { 'multiple' : true },
    // form_chosen_multiple: true,
  },
  {
    key: 'sectionProductSubscriptionLease',
    form_html: () => '',
  },
  {
    key: 'seasonID',
    text: 'New Car Park Product',
    form_select: {
      data: [],
      formatSelectOptionText: season => {
        let option = season.name;
        if(season._zone && season._zone.name) {
          option = season._zone.name + ' - ' + option
        }
        if(season._disabled || season._actualBayAvailable) {
          option += ' (' + (season._disabled || season._actualBayAvailable) + ')'
        }
        return option;
      }
    },
    form_chosen: true,
    form_edit_input_attr: {
      disabled: true,
    },
  },
  {
    key: '_commencementDate',
    text: 'Product Change Effective Date',
    form_datepicker: {
      beforeShowDay: function(date) {
        return commencementDateValidate(date);
      },
    },
  },
  {
    key: 'sectionProductChangeSummary',
    form_section: 'Product Change Summary',
  },
  {
    key: 'applicationStaff',
    text: 'Staff Name',
    form_select: [],
    form_chosen: true,
    form_edit_input_attr: {
      disabled: true,
    },
    form_edit_validation: [],
  },
  {
    key: 'applicationStaffNo',
    text: 'Staff No',
    form_input_attr: {
      disabled: true,
    },
    form_edit_validation: [],
  },
];

const PARAM_MAP = helper.transformParamToMap(PARAM);

export default {
  name: "PagePLProductChangeForm",
  components: {
    TemplateBasic,
    TemplateButton,
    TemplateFeedback,
    AppForm,
    AppModalForm,
    PagePLProductChangeFormLease,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Parking License', url: '/parkinglicense' },
        { name: 'Product Change Application', url: '/plProductChange' },
      ],

      API_PATH: "/api2/application/",
      PARAM,
      PARAM_MAP,

      pageTitle: null,
      pageShowData: false,
      pageShowAdd: false,
      pageCanAdd: false,
      pageShowEdit: false,
      pageCanEdit: false,

      pageSeasonChanged: [],

      pageTenant: null,
      pageStaff: null,
      pageCarpark: null,
      pageCustomer: null,
      pagePasscard: null,

      pageLicense: null,
      pageSeason: undefined,
      pageFees: {},
      pageParker: undefined,

      approvalShow: false,
      approvalShowApprove: false,
      approvalShowReject: false,
      approvalShowVoid: false,
      approvalShowComplete: false,

      approvalText: null,
      approvalReject: false,
      approvalRejectReason: null,
      approvalRejectReasonError: null,

      oldSelection: [],
    }
  },
  mounted() {
    this.permission = this.$route.path.includes('Force') ? 'secretadmin' : helper.getPermission(this)
    if(!helper.hasViewPermission(this.permission)) {
      return;
    }
    
    if(!this.$route.path.includes('Force')) {
      this.$nextTick(() => {
        helper.setSidebar('/plProductChange');
      });
    }

    this.$refs['warning'].setFeedbackError('No cancellation after product change application submitted');
    
    this.hideFormFromKey('licenseID');
    this.loadTenant();
    this.updateDateValidation();

    if(helper.checkRoleIsParker()) {
      this.PARAM_MAP['applicationStaff'].form_add_hide = true;
      this.PARAM_MAP['applicationStaffNo'].form_add_hide = true;
      this.PARAM_MAP['applicationStaff'].form_edit_hide = true;
      this.PARAM_MAP['applicationStaffNo'].form_edit_hide = true;
      this.PARAM_MAP['applicationStaff'].form_input_validation = [];
      this.PARAM_MAP['applicationStaffNo'].form_input_validation = [];
    }
  },
  methods: {
    hideFormFromKey(key) {
      this.pageShowAdd = false;
      this.pageShowEdit = false;

      if(key === null) {
        this.pageShowAdd = true;
        this.pageShowEdit = true;
      }

      let hide = false;
      this.PARAM.forEach(parameter => {
        if(parameter.key === key) {
          hide = true;
        }

        if(hide) {
          parameter.form_hide = hide;
          return;
        }

        parameter.form_hide = hide;
      });
    },

    // 1. load staff, customer & carpark
    // 2a. if add - init application, load license, license lease
    // 2b. if edit - load application, license (specific, for customer + carpark), application data, application lease
    // 3. load leases related (parker, season, season fees)
    loadTenant() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading tenant data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/tenant',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageTenant = response.data;
          this.loadEntitlement();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'tenant data'));
        });
    },
    loadEntitlement() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading entitlement data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/entitlement',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageEntitlement = response.data;
          this.loadStaff();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'entitlement data'));
        });
    },
    loadStaff() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading staff data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/personnel/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          helper.inputSelectSetOption(this.PARAM_MAP['applicationStaff'], response.data);
          this.loadCustomer();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'staff data'));
        });
    },
    loadCustomer() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading profile data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageCustomer = response.data;
          this.loadCarpark();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'profile data'));
        });
    },
    loadCarpark() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading car park data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();

          // helper.inputSelectSetOption(this.PARAM_MAP['carparkID'], this.pageCarpark = response.data);
          // this.loadZone();

          this.pageCarpark = response.data
          this.setCarparInput();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'car park data'));
        });
    },
    setCarparInput() {
      let feedbackItem = 'car park license data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/license',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();

          let allParkingLicense = response.data;
          this.pageCarpark = this.pageCarpark.filter(k => {
            return allParkingLicense.find(j => j.carparkID === k.id)
          });

          helper.inputSelectSetOption(this.PARAM_MAP['carparkID'], this.pageCarpark);
          this.loadZone();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadZone() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading car park zone data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/zone',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageZone = response.data;
          this.loadApplication();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'car park zone data'));
        });
    },

    loadApplication() {
      let applicationID = this.$route.query.applicationID;
      if(applicationID) {
        let feedbackItem = 'parking license product change application info';
        this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
        this.$http
          .get(
            helper.SERVER_URL + '/api2/request?carparkID=' + this.$route.query.carparkID + '&applicationID=' + applicationID + '&type1=productChange',
            helper.createAxiosConfig()
          )
          .then(response => {
            let resultMeta = helper.processAxiosResponse(this, response);
            response.data = response.data.filter(k => k.createDate > 1545955200);

            let temp = response.data[0];
            let application = {};
            application['applicationID'] = temp['applicationID'];
            application['licenseID'] = temp['licenseID'];
            application['carparkID'] = temp['carparkID'];
            application['customerID'] = temp['customerID'];
            application['seasonID'] = temp['data1'];
            application['seasonFees'] = temp['data3'];
            application['applicationStaff'] = temp['data2'];
            application['_commencementDate'] = helper.formatDate(temp['date1']);
            application['status'] = temp['status1'];
            application['lease'] = response.data;
            this.$refs['pageForm'].setForm(false, application);
            this.$refs['pageTableLease'].setLeaseData(application['lease'] = response.data, false);

            if(application['status'] === 'Pending Approval' || application['status'] === 'Pending') {
              this.approvalShow = true;
              this.approvalShowApprove = true;
              this.approvalShowReject = true;
              this.approvalShowVoid = true;
              this.pageCanEdit = true;
            } else if(application['status'] === 'Approved') {
              this.approvalShow = false;
              this.approvalShowApprove = false;
              this.approvalShowReject = false;
              this.approvalShowVoid = false;
              this.approvalShowComplete = true;
              this.PARAM.forEach(k => k['form_input_attr'] = {disabled : true});
            } else {
              this.approvalShow = false;
              this.approvalShowApprove = false;
              this.approvalShowReject = false;
              this.approvalShowVoid = false
              this.approvalShowComplete = false;
              this.PARAM.forEach(k => k['form_input_attr'] = {disabled : true});
            }
            
            this.onApplicationStaffChange();

            this.pageTitle = 'Parking License Product Change Application ' + (this.pageApplication = helper.plFormPLPCNum(application['applicationID'], application['carparkID']));
            this.pageShowData = true;

            this.loadLicense();
          })
          .catch(error => {
            this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
          })
      } else {
        this.pageCanAdd = true;
        let tempData = this.$refs['pageForm'].getFormDefaultData();
        tempData.lease = [{}];
        tempData['carparkID'] = this.$route.query.carparkID || tempData['carparkID'];
        tempData['licenseID'] = this.$route.query.licenseID || tempData['licenseID'];
        tempData['_commencementDate'] = helper.formatDate(moment().endOf('month').add('day', 1).add('month', 1).startOf('day'));

        this.pageTitle = 'Parking License Product Change Application';
        this.pageShowData = true;
        this.$refs['pageForm'].setForm(true, tempData);

        if(this.$refs['pageForm'].formData['carparkID']) {
          this.loadLicense();
        }
      }
    },

    loadLicense() {
      this.hideFormFromKey('licenseID');
      let formData = this.$refs['pageForm'].formData;

      let url = helper.SERVER_URL;
      if(!this.$refs['pageForm'].formIsAdd) {
        url += '/api2/license/' + formData['licenseID'];
      } else {
        url += '/api2/carpark/' + formData['carparkID'] + '/license/';
      }
      
      let feedbackItem = 'parking license data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();

          // TODO kw1 only show active license & lease
          if(this.$refs['pageForm'].formIsAdd) {
            response.data = response.data.filter(k => k.status === 'Active');
          }
          this.pageLicense = response.data;

          response.data.forEach(k => {
            k['_carpark'] = this.pageCarpark.find(j => j.id === k.carparkID);
            k['_customer'] = this.pageCustomer.find(j => j.id === k.customerID);
          });

          helper.inputSelectSetOption(this.PARAM_MAP['licenseID'], response.data);
          this.hideFormFromKey('sectionProductSubscription');

          if(!this.$refs['pageForm'].formIsAdd) {
            formData['carparkID'] = response.data.find(k => helper.compareID(k.id, formData['licenseID']))['carparkID'];
            this.$refs['pageForm'].$forceUpdate();
            // this.loadApplicationData(formData['applicationData']);

            this.$refs['pageForm'].formData['lease'].forEach(k => k['leaseSelected'] = true);
            this.$refs['pageTableLease'].setLeaseData(this.$refs['pageForm'].formData['lease'], false);
            this.loadLicenseLease();
            return;
          }

          if(formData['licenseID'] && response.data.find(k => helper.compareID(k.id, formData['licenseID']))) {
            this.loadLicenseLease();
          } else {
            this.$refs['pageFeedback'].setFeedbackMessage();
            formData['licenseID'] = null;
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadLicenseLease() {
      this.hideFormFromKey('sectionProductSubscription');

      this.pageSeason = null;
      this.pageParker = null;

      let feedbackItem = 'parking license lease data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/license/' + this.$refs['pageForm'].formData['licenseID'] + '/lease/?current=1',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.latestLease = response.data;

          if(!this.$refs['pageForm'].formIsAdd) {
            this.pageLicenseLease = response.data;
            this.loadPasscard();
            return;
          }

          if(this.$refs['pageForm'].formIsAdd) {
            response.data = response.data.filter(k => k.status === 'Active' && !k['stopBillDate']);
          }

          if(response.data.length === 0) {
            this.$refs['pageFeedback'].setFeedbackError('No active subscription available');
            return;
          }

          this.$refs['pageTableLease'].setLeaseData(this.$refs['pageForm'].formData['lease'] = response.data, true);
          this.loadPasscard();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },

    loadPasscard() {
      this.hideFormFromKey('licenseID');
      let formData = this.$refs['pageForm'].formData;

      let url = helper.SERVER_URL + '/api2/carpark/' + formData['carparkID'] + '/passcard/';

      let feedbackItem = 'parking license passcard'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pagePasscard = response.data;
          this.loadLeaseData();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },

    loadLeaseData() {
      if(!this.pageBay) {
        this.loadBay();
        return;
      }

      if(!this.pageSeason) {
        this.loadSeason();
        return;
      }

      if(!this.pageParker) {
        this.loadParker();
        return;
      }

      helper.inputSelectSetOption(this.PARAM_MAP['_lease'], this.$refs['pageForm'].formData['lease']);

      this.calculateParkingFees();
    },
    loadBay() {
      this.hideFormFromKey('sectionProductSubscription');

      let feedbackItem = 'bay data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let url = helper.SERVER_URL + '/api2';
      url += '/bay/?1=1';
      let carparkFilter = this.$refs['pageForm'].formData['carparkID'];
      if(carparkFilter) {
        url += '&carparkID=' + carparkFilter;
      }

      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageBay = response.data;
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadSeason() {
      this.hideFormFromKey('sectionProductSubscription');

      let feedbackItem = 'product data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + this.$refs['pageForm'].formData['carparkID'] + '/season/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageSeason = response.data;
            this.pageSeason.forEach(k => {
              k['_zone'] = this.pageZone.find(j => helper.compareID(j.id, k.zoneID));
              k['_bayAvailable'] = this.pageBay.filter(j => j.seasonID === k.id && !j.leaseID).length;
            })
            this.onLeaseSelected();
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadSeasonFees(seasonID) {
      this.hideFormFromKey('sectionProductChangeSummary');

      this.pageFees[seasonID] = null;

      let feedbackItem = 'product fees data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          // helper.SERVER_URL + '/api2/season/' + seasonID + '/currentSeasonFees/',
          helper.SERVER_URL + '/api2/season/' + seasonID + '/seasonFees/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            // if(this.pageFees[seasonID] = response.data[0]) {
            // if(this.pageFees[seasonID] = response.data.find(k => k.isActive)) {
            if(this.pageFees[seasonID] = response.data) {
              this.$refs['pageFeedback'].setFeedbackMessage();
              this.calculateParkingFees();
              this.onLeaseSelectedOrNewSeasonChange();
            } else {
              this.$refs['pageFeedback'].setFeedbackError('No active ' + feedbackItem + ' available.');
            }
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadParker() {
      this.hideFormFromKey('sectionProductSubscription');

      let customerID = helper.inputSelectFindOption(this.PARAM_MAP['licenseID'], this.$refs['pageForm'].formData['licenseID']).customerID;

      let feedbackItem = 'parker data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer/' + customerID + '/parker/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageParker = response.data;
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },

    isTenant() {
      let formData = this.$refs['pageForm'].formData;
      let customerID = helper.inputSelectFindOption(this.PARAM_MAP['licenseID'], formData['licenseID']).customerID;
      return formData['tenant'] = this.pageTenant.find(k => helper.compareID(k.carparkID, formData['carparkID']) && helper.compareID(k.customerID, customerID));
    },

    calculateParkingFees() {
      let formData = this.$refs['pageForm'].formData;
      formData.lease = formData.lease || [];
      formData['applicationTotalPayable'] = 0.00;
      formData.lease.forEach(leaseData => {
        this.$refs['pageTableLease'].removeLeaseDataSeasonField(leaseData);
      });
      this.$refs['pageTableLease'].setLeaseTotal();

      if(this.checkSeasonFees()) {
        return;
      }

      let leaseTotal = {};
      this.$refs['pageTableLease'].PRODUCT_PARAMS.forEach(k => leaseTotal[k] = 0);

      let tandemCalculated = {};
      formData.lease.forEach(leaseData => {
        if(!this.$refs['pageForm'].formIsAdd) {
          let originalLease = this.pageLicenseLease.find(k => helper.compareID(k.id, leaseData['leaseID']));
          if(originalLease) {
            leaseData['status'] = originalLease['status'];
            leaseData['reason'] = originalLease['reason'];
            leaseData['passcardID'] = originalLease['passcardID'];
            leaseData['leaseSubscriptionStatus'] = originalLease['status'];
          }
        }

        if(leaseData['isParkAide']) {
          leaseData['leasePasscard'] = 'N/A';
          leaseData['leasePasscardStatus'] = 'ParkAide Blocked';
          if(leaseData['status'] === 'Active' || leaseData['status'] === 'Pending Termination') {
            if(new moment() > helper.parseDateTime(leaseData['commencementDate'])) {
              if(!leaseData['isBlock']) {
                leaseData['leasePasscardStatus'] = 'ParkAide Active';
              }
            }
          }
          leaseData['leaseIsParkAide'] = 'Yes';
        } else {
          let passcard = this.pagePasscard.find(k => helper.compareID(k.id, leaseData['passcardID']));
          if(passcard) {
            leaseData['leasePasscard'] = passcard.sku;
            leaseData['leasePasscardStatus'] = 'Passcard Issued';
            leaseData['leaseIsParkAide'] = 'No';
            leaseData['_passcard'] = passcard;
          } else {
            leaseData['leasePasscard'] = 'N/A';
            leaseData['leasePasscardStatus'] = 'N/A';
            leaseData['leaseIsParkAide'] = 'No';
          }
        }
        
        let applicationPaymentPlan = parseInt(leaseData['paymentPlan']);
        if(applicationPaymentPlan === undefined || applicationPaymentPlan === null) {
          return;
        }

        let applicationCommencementDateText = leaseData['commencementDate'];
        if(applicationCommencementDateText === undefined || applicationCommencementDateText === null) {
          return;
        }

        let applicationCommencementDate = helper.parseDateTime(applicationCommencementDateText);
        let daysInMonth = applicationCommencementDate.daysInMonth();
        let startDay = applicationCommencementDate.date();

        if(leaseData['nextBillDate']) {
          let date = helper.parseDateTime(leaseData['nextBillDate']);
          leaseData['leaseNextBillingMonth'] = date ? date.format('MM/YYYY') : '';
        } else {
          let latestLeaseState = this.latestLease.find(k => k.id === leaseData['leaseID'])
          if(latestLeaseState && latestLeaseState['nextBillDate']) {
            let date = helper.parseDateTime(latestLeaseState['nextBillDate']);
            leaseData['leaseNextBillingMonth'] = date ? date.format('MM/YYYY') : '';
          }
        }

        if(leaseData['parkerID']) {
          let parker = this.pageParker.find(k => k['id'] === leaseData['parkerID'])
          leaseData['_parker'] = parker;
          leaseData['parkerName'] = parker['name'];
          this.$refs['pageTableLease'].setLeaseDataParker(leaseData, parker);
        } else {
          let parker = this.pageParker.find(k => k['id'] === leaseData['parkerID'])
          leaseData['_parker'] = parker;
          leaseData['parkerName'] = parker['name'];
          this.$refs['pageTableLease'].setLeaseDataParker(leaseData, parker);
        }
        
        let season = this.pageSeason.find(k => helper.compareID(k.id, leaseData['seasonID']));
        leaseData['leaseProductName'] = (season || {}).name;

        let zone = this.pageZone.find(k => helper.compareID(k.id, (season || {})['zoneID']));
        leaseData['leaseZone'] = (zone || {}).name;
        
        let product = this.pageFees[leaseData['seasonID']].find(k => helper.compareID(k.id, leaseData['seasonFees']));
        // if(!product || product.startDate > leaseData['commencementDate']) {
        if(!product) {
          product = this.pageFees[leaseData['seasonID']].find(k => k.isActive)
          if(!product) {
            for(let temp of this.pageFees[leaseData['seasonID']]) {
              if(temp.startDate <= leaseData['commencementDate']) {
                product = temp;
                break;
              }
            }
          }
        }
        if(!product) return;
        leaseData['seasonFeesID'] = product.id;

        if(!leaseData.leaseSelected) {
          return;
        }

        product.feesDeposit = parseFloat(product['deposit'] || 0);
        product.feesEstablishment = parseFloat(product['establishment'] || 0);
        product.fees1Month = parseFloat(product['monthly'] || 0);
        product.fees3Month = parseFloat(product['quarterly'] || 0) * 3;
        product.fees6Month = parseFloat(product['halfYearly'] || 0) * 6;
        product.fees12Month = parseFloat(product['annually'] || 0) * 12;
        
        leaseData['commencementDate'] = applicationCommencementDate.unix();
        leaseData['commencementDateText'] = helper.formatDate(leaseData['commencementDate']);
        leaseData['paymentPlan'] = applicationPaymentPlan;

        leaseData['leaseProductDeposit'] = product.feesDeposit;
        leaseData['leaseProductDepositText'] = helper.formatMoney(leaseData['leaseProductDeposit']);
        leaseData['leaseProductEstbFee'] = product.feesEstablishment;

        switch(applicationPaymentPlan) {
          case 1:
            leaseData['paymentPlanText'] = 'Monthly';
            if(startDay == 1) {
              leaseData['leaseProductInitialParkingFee'] = product.fees1Month;
            } else {
              leaseData['leaseProductInitialParkingFee'] = (daysInMonth - startDay + 1) * (product.fees1Month / daysInMonth);
            }
            leaseData['leaseProductParkingFee'] = product.fees1Month;
            leaseData['leaseProductParkingFeeText'] = helper.formatMoney(leaseData['leaseProductParkingFee']) + ' / month';
            break;
          case 2:
            leaseData['paymentPlanText'] = 'Quarterly';
            if(startDay == 1) {
              leaseData['leaseProductInitialParkingFee'] = product.fees3Month;
            } else {
              leaseData['leaseProductInitialParkingFee'] = (daysInMonth - startDay + 1) * (product.fees1Month / daysInMonth);
              leaseData['leaseProductInitialParkingFee'] += product.fees3Month;
            }
            leaseData['leaseProductParkingFee'] = product.fees3Month;
            leaseData['leaseProductParkingFeeText'] = helper.formatMoney(leaseData['leaseProductParkingFee']) + ' / quarter';
            break;
          case 3:
            leaseData['paymentPlanText'] = 'Half-yearly';
            if(startDay == 1) {
              leaseData['leaseProductInitialParkingFee'] = product.fees6Month;
            } else {
              leaseData['leaseProductInitialParkingFee'] = (daysInMonth - startDay + 1) * (product.fees1Month / daysInMonth);
              leaseData['leaseProductInitialParkingFee'] += product.fees6Month;
            }
            leaseData['leaseProductParkingFee'] = product.fees6Month;
            leaseData['leaseProductParkingFeeText'] = helper.formatMoney(leaseData['leaseProductParkingFee']) + ' / half-year';
            break;
          case 4:
            leaseData['paymentPlanText'] = 'Annually';
            if(startDay == 1) {
              leaseData['leaseProductInitialParkingFee'] = product.fees12Month;
            } else {
              leaseData['leaseProductInitialParkingFee'] = (daysInMonth - startDay + 1) * (product.fees1Month / daysInMonth);
              leaseData['leaseProductInitialParkingFee'] += product.fees12Month;
            }
            leaseData['leaseProductParkingFee'] = product.fees12Month;
            leaseData['leaseProductParkingFeeText'] = helper.formatMoney(leaseData['leaseProductParkingFee']) + ' / annual';
            break;
        }

        leaseData['leaseProductInitialPayment'] = product.feesDeposit + product.feesEstablishment + leaseData['leaseProductInitialParkingFee'];

        this.$refs['pageTableLease'].PRODUCT_PARAMS.forEach(k => {
          tandemCalculated[k] = tandemCalculated[k] || [];
          
          let originalLease = leaseData['leaseID'] ? this.latestLease.find(k => k.id === leaseData['leaseID']) : leaseData
          if(!originalLease['pairID']) {
            leaseTotal[k] += leaseData[k];
          } else if(!tandemCalculated[k].includes(originalLease['pairID'])) {
            leaseTotal[k] += leaseData[k];
            tandemCalculated[k].push(originalLease['pairID'])
          }

          leaseData[k + 'Text'] = leaseData[k + 'Text'] || helper.formatMoney(leaseData[k]);
        });
      });

      this.$refs['pageTableLease'].setLeaseTotal(leaseTotal);
      formData['applicationTotalPayable'] = leaseTotal['leaseProductInitialPaymentText'];
      this.hideFormFromKey('sectionProductChangeSummary');
    },
    checkSeasonFees() {
      let formData = this.$refs['pageForm'].formData;
      for(let leaseData of formData.lease) {
        if(leaseData['seasonID'] && this.pageFees[leaseData['seasonID']] === undefined) {
          // load season fees
          this.loadSeasonFees(leaseData['seasonID']);
          return true;
        }
      };
    },

    onCancelButtonClick() {
      let url = this.$route.query.pending ? helper.WEB_URL + '/plProductChangePending' : helper.WEB_URL + '/plProductChange';
      helper.redirect({ path: url, query: { carparkID: this.$refs['pageForm'].formData['carparkID'] }});
    },
    onSaveButtonClick() {
      if(!this.$refs['pageForm'].validateForm() && !this.validateApplicationData()) {
        if(this.$refs['pageForm'].formIsAdd) {
          this.addApplication({});
        } else {
          this.editApplication({});
        }
      }
    },
    validateApplicationData() {
      let formData = this.$refs['pageForm'].formData;
      let hasSelected = false;
      if(!formData.lease.find(k => k.leaseSelected)) {
        this.$refs['pageTableLease'].$refs['leaseFeedback'].setFeedbackError('Please select at least one subscription to proceed');
        $(document).scrollTop($('#jt-form-div-sectionProductSubscription')[0].offsetTop);
        return true;
      }

      // TODO kw1 validate whatever special product change field
    },
    
    addApplication(data) {
      let formData = this.$refs['pageForm'].formData;

      let temp = {}
      temp['carparkID'] = formData['carparkID'];
      temp['seasonID'] = formData['seasonID'];
      temp['seasonFeesID'] = formData['seasonFeesID'];
      temp['commencementDate'] = helper.parseDateTime(formData['_commencementDate']).format('YYYY/MM/DD');
      temp['applicationStaff'] = formData['applicationStaff'];
      temp['operatorID'] = this.pageCarpark.find(k => helper.compareID(k.id, formData['carparkID'])).operatorID;
      temp['leases'] = JSON.stringify(formData['lease'].filter(k => k.leaseSelected));

      let feedbackItem = 'parking license product change application';
      this.$refs['pageFeedback'].setFeedbackLoading('Adding ' + feedbackItem);
      this.$http
        .post(
          helper.API_URL + '/api2/licenseProductChange/create',
          querystring.stringify(temp),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(JSON.parse(localStorage.getItem('user')).username === 'kahwei.chuah@july.technology') {
            this.$http
              .post(
                helper.API_URL + '/api2/licenseProductChange/approve',
                querystring.stringify({
                  leases: JSON.stringify([{
                    id: response.data[0].id,
                    applicationID: response.data[0].applicationID,
                    licenseID: response.data[0].licenseID,
                    account: JSON.parse(localStorage.getItem('user')).username,
                  }])
                }),
                helper.createAxiosFormConfig()
              )
              .then(response => {
                this.upsertDataComplete('Successfully approve ' + feedbackItem);
              })
              .catch(error => {
                this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'adding', feedbackItem));
              })
          } else {
            this.upsertDataComplete('Successfully added ' + feedbackItem);
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'adding', feedbackItem));
        })
    },
    editApplication(data) {
      let formData = this.$refs['pageForm'].formData;

      let temp = {}
      temp['commencementDate'] = helper.parseDateTime(formData['_commencementDate']).format('YYYY/MM/DD');
      temp['seasonFeesID'] = formData['seasonFeesID'];
      temp['applicationStaff'] = formData['applicationStaff'];
      temp['leases'] = JSON.stringify(formData['lease'].filter(k => k.leaseSelected));

      let feedbackItem = 'parking license product change application';
      this.$refs['pageFeedback'].setFeedbackLoading('Updating ' + feedbackItem);
      this.$http
        .put(
          helper.API_URL + '/api2/licenseProductChange/update',
          querystring.stringify(temp),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully update ' + feedbackItem);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'updating', feedbackItem));
        })
    },
    upsertDataComplete(message) {
      this.$refs['pageFeedback'].setFeedbackMessage(message);
      let url = this.$route.query.pending ? helper.WEB_URL + '/plProductChangePending' : helper.WEB_URL + '/plProductChange';
      helper.redirect({ path: url, query: { carparkID: this.$refs['pageForm'].formData['carparkID'] }});
    },
    
    onFormInput(formData, formParameter, input) {
      if(formParameter.key === 'carparkID') {
        formData['licenseID'] = null;
        formData['_lease'] = [];
        formData['lease'] = [];
        this.pageBay = null;
        this.loadLicense();
      } else if(formParameter.key === 'licenseID') {
        formData['_lease'] = [];
        formData['lease'] = [];
        formData['customerID'] = helper.inputSelectFindOption(this.PARAM_MAP['licenseID'], formData['licenseID']).customerID;
        this.loadLicenseLease();
      } else if(formParameter.key === '_lease') {
        formData['lease'].forEach(k => {
          if(formData['_lease'].includes('All Subscription')) {
            k.leaseSelected = true;
          } else {
            k.leaseSelected = formData['_lease'].includes('' + k.id);
          }
        });

        // if one tandem is selected, the pair/group must select together
        if(!formData['_lease'].includes('All Subscription')) {
          formData['lease'].forEach(k => {
            if(k.leaseSelected && k.pairID) {
              formData['lease'].forEach(j => {
                if(j.pairID === k.pairID) {
                  j.leaseSelected = true;
                }
              });
            }
          });
        }
        
        this.calculateParkingFees();
        this.$refs['pageTableLease'].$forceUpdate();
        this.onLeaseSelected();
        this.updateDateValidation();
      } else if(formParameter.key === '_commencementDate') {
        formData['seasonFees'] = null;
        this.$refs['pageForm'].$refs['jt-form-element-seasonID'][0].setInputError();
        this.onLeaseSelected();
      } else if(formParameter.key === 'productChangeRefundMethod') {
        this.hideFormFromKey(null);
      } else if(formParameter.key === 'seasonID') {
        this.$refs['pageForm'].$refs['jt-form-element-seasonID'][0].setInputError();
        this.onLeaseSelectedOrNewSeasonChange();
        this.updateDateValidation();
      } else if(formParameter.key === 'applicationStaff') {
        this.onApplicationStaffChange();
      }
    },
    onApplicationStaffChange() {
      let staff = helper.inputSelectFindOption(this.PARAM_MAP['applicationStaff'], this.$refs['pageForm'].formData['applicationStaff']) || {}
      this.$refs['pageForm'].formData['applicationStaffNo'] = staff['personnelCode'];
    },

    async onLeaseSelected() {
      if(!this.$refs['pageForm'].formIsAdd) {
        helper.inputSelectSetOption(this.PARAM_MAP['seasonID'], this.pageSeason);
        this.onLeaseSelectedOrNewSeasonChange();
        return;
      }

      let formData = this.$refs['pageForm'].formData;

      let selectedLease = formData['lease'].find(k => k.leaseSelected);
      
      let newSeasonID = formData['seasonID'];

      if(selectedLease && helper.compareID(newSeasonID, selectedLease.seasonID)) {
        formData['seasonID'] = null;
      }

      if(selectedLease) {
        let minLeaseDate;
        if(this.$route.path.includes('Force')) {
          minLeaseDate = helper.parseDateTime(selectedLease['commencementDate']).startOf('month');
        } else {
          minLeaseDate = helper.parseDateTime(selectedLease['commencementDate']).add('month', 1).startOf('month');
        }
        if(helper.parseDateTime(formData['_commencementDate']) < minLeaseDate ) {
          formData['commencementDate'] = minLeaseDate;
          formData['_commencementDate'] = helper.formatDate(formData['commencementDate']);
        }

        let previousProductChangeForm = await this.$http
            .get(
              helper.SERVER_URL + '/api2/request?type1=productChange&leaseID=' + selectedLease['id'],
              helper.createAxiosConfig()
            )
            .then(response => {
              let resultMeta = helper.processAxiosResponse(this, response);
              return response.data.filter(k => k.status1 === 'Pending Approval');
            });
        
        if(previousProductChangeForm.length > 0) {
          this.hideFormFromKey('sectionProductSubscriptionLease');
          this.$refs['pageFeedback'].setFeedbackError('The Change Product Request Form submitted before at ' + helper.plFormPLPCNum(previousProductChangeForm[0]['applicationID'], previousProductChangeForm[0]['carparkID']));
          return;
        } else {
          this.hideFormFromKey('sectionProductChangeSummary');
          this.$refs['pageFeedback'].setFeedbackError();
        }
      }

      // if(this.$refs['pageForm'].formIsAdd) {
      // } else {
      //   helper.inputSelectSetOption(this.PARAM_MAP['seasonID'], this.pageSeason);
      //   return;
      // }

      // TODO kw1 can product be edit after submit?
      // if(!this.$refs['pageForm'].formIsAdd) {
      //   usableSeason = response.data;
      // }
      let customerIsTenant = this.isTenant();
      let keepInSelection = false;
      let usableSeason = this.pageSeason.filter(k => {
        if(selectedLease) {
          if(selectedLease['bayType'] === 3) {
            if(k['bayType'] !== 3) {
              return false;
            }
          } else {
            if(k['bayType'] === 3) {
              return false;
            }
          }
        }
        if(!k['isEnable']) {
          return false;
        }
        if(k['startDate'] && helper.parseDateTime(k['startDate']) > helper.parseDateTime(formData['_commencementDate'])) {
          return false;
        }
        if(k['stopDate'] && helper.parseDateTime(k['stopDate']) <= moment().startOf('day')) {
          return false;
        }
        if(k['isTenant']) {
          if(!formData['tenant']) {
            k['_disabled'] = 'Tenant Only'
            return false;
          }
        } else {
          if(formData['tenant']) {
            k['_disabled'] = 'Non-Tenant Only'
            return false;
          }
        }
        if(!k['isPublic']) {
          if(helper.checkRoleIsParker()) {
            k['_disabled'] = 'Non-Public'
            return keepInSelection;
          }
        }
        if(k['entitleOnly']) {
          if(!formData['tenant']) {
            k['_disabled'] = 'Entitlement Only'
            return helper.checkRoleIsParker() ? false : keepInSelection;
          }
          
          let entitlement = this.pageEntitlement.find(j => 
            helper.compareID(j['seasonID'], k['id']) 
            && helper.compareID(j['tenantID'], formData['tenant']['id']))
          if(!entitlement || !entitlement.bayCount) {
            k['_disabled'] = 'Entitlement Unallocated'
            return keepInSelection;
          }

          let usedEntitlementBay = this.pageBay.filter(j => j.seasonID === k.id && j.leaseID && helper.compareID(j['customerID'], formData['customerID'])).length;
          k['_actualBayAvailable'] = entitlement.bayCount - usedEntitlementBay;
        } else {
          k['_actualBayAvailable'] = k['_bayAvailable'];
        }
        if(!k['_actualBayAvailable']) {
          k['_disabled'] = 'Insufficient Bay' 
          return true;
          return keepInSelection;
        }
        
        k['_disabled'] = null;
        return true;
      });

      if(selectedLease) {
        usableSeason = usableSeason.filter(k => k.id !== selectedLease.seasonID)
      }

      if(!usableSeason.some(k => helper.compareID(k.id, newSeasonID))) {
        formData['seasonID'] = null;
      }

      helper.inputSelectSetOption(this.PARAM_MAP['seasonID'], usableSeason);

      if(usableSeason.length === 0) {
        this.$refs['pageFeedback'].setFeedbackError('No product available.');
      }
      
      this.onLeaseSelectedOrNewSeasonChange();
    },
    updateDateValidation() {
      try {
        let self = this;
        commencementDateValidate = function(date) {
          if(date.getDate() !== 1) {
            return false;
          }

          if(self.$route.path.includes('Force')) {
            try {
              let selectedLease = self.$refs['pageForm'].formData.lease.find(k => k.leaseSelected);
              if(selectedLease) {
                if(moment(date) < helper.parseDateTime(selectedLease['commencementDate'])) {
                  return false;
                }
              }
            } catch(e) {
            }
            return true;
          }

          let current = moment().startOf('day');
          let oneMonthAway = moment().endOf('month').add(1, 'days').add(1, 'months').startOf('day');
          if(moment(date) < oneMonthAway) {
            return false;
          }
          
          let threeMonthAfterStart = oneMonthAway.add(3, 'months');
          if(moment(date) >= threeMonthAfterStart) {
            return false;
          }

          try {
            let selectedLease = self.$refs['pageForm'].formData.lease.find(k => k.leaseSelected);
            if(selectedLease) {
              if(moment(date) <= helper.parseDateTime(selectedLease['commencementDate'])) {
                return false;
              }
            }
          } catch(e) {
          }

          return true;
        }
        $('#jt-form-input-_commencementDate').datepicker('update');
      } catch (e) {
      }
    },

    onLeaseSelectedOrNewSeasonChange() {
      this.pageSeasonChanged.splice(0);

      let formData = this.$refs['pageForm'].formData;
      formData['seasonFeesID'] = null;

      let newSeasonID = formData['seasonID'];
      if(!newSeasonID) {
        return;
      }

      this.$refs['pageFeedback'].setFeedbackMessage();
      if(!this.pageFees[newSeasonID]) {
        this.loadSeasonFees(newSeasonID);
        return;
      }

      let selectedLease = formData.lease.find(k => k.leaseSelected);
      if(!selectedLease) {
        return;
      }
      
      this.hideFormFromKey('sectionProductChangeSummary');
      
      let oldSeason = this.pageSeason.find(k => helper.compareID(k.id, selectedLease.seasonID));
      let oldSeasonID = oldSeason.id;
      let newSeason = this.pageSeason.find(k => helper.compareID(k.id, newSeasonID));

      let temp1 = {}
      temp1['status'] = 'Current Product';
      temp1['product'] = oldSeason['_zone'] ?  oldSeason['_zone']['name'] + ' - ' : '';
      temp1['product'] += oldSeason['name'];
      let oldSeasonFees = this.pageFees[oldSeasonID].find(k => k.isActive) || {};
      temp1['deposit'] = helper.formatMoney(oldSeasonFees['deposit']);
      temp1['parkingFees'] = this.setChangeProductParkingFees(oldSeasonFees, selectedLease.paymentPlan);

      let temp2 = {}
      temp2['status'] = 'New Product';
      temp2['product'] = newSeason['_zone'] ?  newSeason['_zone']['name'] + ' - ' : '';
      temp2['product'] += newSeason['name'];

      let earliestFeesDate;
      let newSeasonFees = this.pageFees[newSeasonID].find(k => helper.compareID(k.id, formData['seasonFees']));
      if(!newSeasonFees) {
        newSeasonFees = this.pageFees[newSeasonID].find(k => k.isActive);
        if(!newSeasonFees) {
          let _commencementDateText = formData['_commencementDate'];
          let _commencementDate = helper.parseDateTime(_commencementDateText);

          for(let temp of this.pageFees[newSeasonID]) {
            if(temp.startDate <= _commencementDate.unix()) {
              newSeasonFees = temp;
              break;
            }
            if(!earliestFeesDate || earliestFeesDate > temp.startDate) {
              earliestFeesDate = temp.startDate;
            }
          }
        }
      }

      if(!newSeasonFees) {
        if(earliestFeesDate) {
          this.$refs['pageForm'].$refs['jt-form-element-seasonID'][0].setInputError(newSeason['name'] + ' product do not have product fee at this commencement date, this product fee start on ' + helper.formatDate(earliestFeesDate));
        } else {
          this.$refs['pageForm'].$refs['jt-form-element-seasonID'][0].setInputError(newSeason['name'] + ' product do not have product fee');
        }
        $(document).scrollTop($('#jt-form-div-seasonID')[0].offsetTop);
        return;
      }

      temp2['deposit'] = helper.formatMoney(newSeasonFees['deposit']);
      temp2['parkingFees'] = this.setChangeProductParkingFees(newSeasonFees, selectedLease.paymentPlan);

      this.pageSeasonChanged.splice(0);
      this.pageSeasonChanged.push(temp1);
      this.pageSeasonChanged.push(temp2);

      formData['seasonFeesID'] = newSeasonFees['id'];
      
      this.hideFormFromKey(null);
    },
    setChangeProductParkingFees(productFees, paymentPlan) {
      switch(paymentPlan) {
        case 1:
          return helper.formatMoney(productFees['monthly']) + ' / month';
        case 2:
          return helper.formatMoney(productFees['quarterly']) + ' / quarter';
        case 3:
          return helper.formatMoney(productFees['halfYearly']) + ' / half-year';
        case 4:
          return helper.formatMoney(productFees['annually']) + ' / annual';
      }
    },

    onApplicationApproveClick() {
      this.approvalAction = 'approve';
      this.approvalText = 'Approve parking license product change application ' + this.pageApplication;
      this.approvalReject = false;
      this.$refs['pageApprovalModal'].setModalOpen(false, 'Approve Application');
    },
    onApplicationRejectClick() {
      this.approvalAction = 'reject';
      this.approvalText = 'Reject parking license product change application ' + this.pageApplication;
      this.approvalReject = true;
      this.approvalRejectReason = '';
      this.approvalRejectReasonError = '';
      this.$refs['pageApprovalModal'].setModalOpen(false, 'Reject Application');
    },
    onApplicationVoidClick() {
      this.approvalAction = 'void';
      this.approvalText = 'VOID parking license product change application ' + this.pageApplication;
      this.approvalReject = false;
      this.$refs['pageApprovalModal'].setModalOpen(false, 'VOID Application');
    },
    onCompleteButtonClick() {
      this.updateApplicationStatus('complete');
    },
    pageApprovalModalConfirm() {
      if(this.approvalAction === 'reject') {
        if(!this.approvalRejectReason) {
          this.approvalRejectReasonError = 'Reason of Reject cannot be empty';
          return;
        } else {
          this.approvalRejectReasonError = '';
        }
      }

      this.updateApplicationStatus(this.approvalAction);
    },
    updateApplicationStatus(action) {
      this.$refs['pageApprovalModal'].setModalClose('');

      let formData = this.$refs['pageForm'].formData;

      let feedbackItem = 'parking license product change application ' + this.pageApplication + ' status';
      this.$refs['pageFeedback'].setFeedbackLoading('Updating ' + feedbackItem);
      this.$http
        .post(
          helper.API_URL + '/api2/licenseProductChange/' + action,
          querystring.stringify({
            leases: JSON.stringify(formData['lease']),
            rejectReason: this.approvalRejectReason,
            account: JSON.parse(localStorage.getItem('user')).username,
          }),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully update ' + feedbackItem);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'updating', feedbackItem));
        })
    },

    hasAddOrEditPermission() {
      return this.pageIsAdd ? helper.hasAddPermission(this.permission) : helper.hasEditPermission(this.permission);
    },
    hasAddPermission() {
      return helper.hasAddPermission(this.permission);
    },
    hasEditPermission() {
      return helper.hasEditPermission(this.permission);
    },
    hasApprovePermission() {
      return helper.hasPermission(this.permission + '.approve', false);
    },
    hasRejectPermission() {
      return helper.hasPermission(this.permission + '.reject', false);
    },
    hasVoidPermission() {
      return helper.hasPermission(this.permission + '.void', false);
    },
    hasDeletePermission() {
      return helper.hasDeletePermission(this.permission);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/ParkingLicense/PagePLProductChangeForm.vue